<template>
  <el-dialog
      :title="dataForm.id != ''?( editType=='view' ? '信息查看' :(dataForm.state=='1'?'胸牌解绑':'胸牌绑定') ):'新增胸牌绑定'"
      :close-on-click-modal="false"
      :visible.sync="visible">

    <el-form label-width="120px" v-if="editType=='view'" class="form viewFormWrapper" style="margin-bottom: 10px">
      <el-row style="margin-bottom: 10px">
        <el-col :span="12">
          <el-form-item label="胸牌ID：">
            <span class="activeColor">{{dataForm.cardId }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态：" >
            <span class="activeColor">{{dataForm.state == '0'?'已解绑':'已绑定' }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="关联人员姓名：" >
            <span class="activeColor">{{dataForm.personName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="身份证号：" >
            <span class="activeColor">{{dataForm.personCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式：" >
            <span class="activeColor">{{dataForm.linkphone }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="角色：" >
            <span class="activeColor">{{dataForm.roleName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="操作历史：" ></el-form-item>
        </el-col>
      </el-row>
      <el-table
              :data="hisTable"
              border
              style="width: 100%;">
        <el-table-column
                type="index"
                align="center"
                label="序号"
                width="50">
        </el-table-column>
        <el-table-column
                prop="optBehavior"
                align="center"
                label="操作">
        </el-table-column>
        <el-table-column
                prop="optUser"
                align="center"
                label="操作人">
        </el-table-column>
        <el-table-column
                prop="optTime"
                align="center"
                width="160"
                label="操作时间">
        </el-table-column>
      </el-table>
    </el-form>

    <el-form :model="dataForm"
             v-if="editType=='edit'"
             :rules="dataRule"
             ref="dataForm"
             @keyup.enter.native="dataFormSubmit()"
             label-width="120px">
      <el-form-item label="胸牌ID：" prop="cardId">
        <el-input v-model.trim="dataForm.cardId" maxlength="20" :disabled="dataForm.state=='1'" show-word-limit clearable></el-input>
      </el-form-item>
      <el-form-item label="关联人员姓名：" prop='personName' style="width:100%;">
        <el-input v-model.trim="dataForm.personName" maxlength="10" :disabled="dataForm.state=='1'" show-word-limit clearable></el-input>
      </el-form-item>
      <el-form-item label="身份证号：" prop='personCode' style="width:100%;">
        <el-input v-model.trim="dataForm.personCode" maxlength="18" :disabled="dataForm.state=='1'" show-word-limit clearable></el-input>
      </el-form-item>
      <el-form-item label="联系方式：" prop='linkphone' style="width:100%;">
        <el-input v-model.trim="dataForm.linkphone"
                  maxlength="11"
                  :disabled="dataForm.state=='1'"
                  show-word-limit clearable></el-input>
      </el-form-item>
      <el-form-item label="角色：" prop='roleCode' style="width:100%;">
        <el-select v-model="dataForm.roleCode" clearable value-key="value" :disabled="dataForm.state=='1'" style="width:100%;" >
          <el-option v-for="(item,index) in  rolesList"
                     :key="index"
                     :label="item.name"
                     :value="item.value"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" v-if="editType=='edit'" @click="dataFormSubmit()">{{dataForm.id != ''?(dataForm.state=='1'?'解绑':'绑定'):'新增绑定'}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import {isRegPhoneNumber,isMobile, isIdcard,} from "@/utils/validate";
  import { mapState } from "vuex";
export default {
  props: {
  },
  components: {

  },
  data() {
    return {
      visible: false,
      rolesList:[],
      fieldList:'',
      editType:"",
      personList:[],
      columns: [{name: 'personName', title: '姓名'}, {name: 'idCard', title: '身份证号'}],
      hisTable:[],
      dataForm: {
        id: '',
        cardId:"",
        state:"",
        personName:"",
        personCode:"",
        linkphone:"",
        uwbUuid:"",
        roleName:"",
      },
      errorData:{},
      dataRule: {
        personName: [{required: true, message: '请输入姓名', trigger: 'blur'},{ min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }],
        linkphone: [{required: true,validator: isMobile, trigger: 'blur'}],
        personCode: [{required: true,validator: isIdcard, trigger: 'blur'}],
        roleCode: [{ required: true, message: '请选择角色', trigger: 'change' }],
        cardId:[{required:true, message:'请输入胸牌卡号',trigger:'blur'},{ min: 1, max: 20, message: '长度在 1 到 50 个字符', trigger: 'blur' }],
      },
      dataTypeList:''
    };
  },
  created() {
    this.getDic('jz_dgwitness_person_role');
  },
  computed: {
    ...mapState({
      stateData:state=>state.user
    }),
    personName: {
      get() {
        return this.dataForm.personName
      },
      set() {
      },
    },

  },
  methods: {
    init(id,type) {

      this.editType = type;
      this.dataForm.id = id || ''
      this.visible = true;

      if (this.dataForm.id) {
        this.$http({
          url: '/evalCardBrands/sysEvalCardBrands/get?id='+id,
          method: 'get'
        }).then(({data}) => {
          if (data && data.code === '1') {

            this.dataForm = data.data.SysEvalCardBrands || {};
            this.dataForm.roleCode = this.dataForm.roleCode.toString()
            this.hisTable = data.data.SysBusOptRecords || [];

          }else{

            this.dataForm =  {
              id: '',
              cardId:"",
              state:"",
              personName:"",
              personCode:"",
              linkphone:"",
              uwbUuid:"",
              roleName:"",
            }
            this.hisTable = [];

          }
        })
      }else{

        this.dataForm =  {
          id: '',
          cardId:"",
          state:"",
          personName:"",
          personCode:"",
          linkphone:"",
          uwbUuid:"",
          roleName:"",
        }
        this.hisTable = [];

      }
    },

    getDic(type) { // 获取字典

      this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
        if (res.data.code === '1') {
          switch (type) {
            case 'jz_dgwitness_person_role':this. rolesList = res.data.data;break;
          }
        }
      })
    },

    dataFormSubmit() {

      this.$refs['dataForm'].validate((valid) => {
        if (valid) {

          if(this.dataForm.state == "1"){
            this.$http({
              url: "/evalCardBrands/sysEvalCardBrands/unbinding",
              method: 'post',
              data: {
                id:this.dataForm.id,
                updateUser:this.stateData.username,
                uwbUuid:this.dataForm.uwbUuid
              }
            }).then(({data}) => {
              if (data && data.code === '1') {

                this.visible = false
                this.$emit('refreshDataList')

              } else {
                this.$message.error(data.msg)
              }
            })

          }else{

            this.dataForm.updateUser = this.stateData.username

            this.$http({
              url: "/evalCardBrands/sysEvalCardBrands/binding",
              method: 'post',
              data: this.dataForm
            }).then(({data}) => {
              if (data && data.code === '1') {

                this.visible = false
                this.$emit('refreshDataList')

              } else {
                this.$message.error(data.msg)
              }
            })



          }

        }
      })

    },

  },
};
</script>
